export default __webpack_public_path__ + "static/media/auditorium_image@2x.78450be4.jpg";